import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { KasootAdminApp } from './app.component';

// firebase
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { firebaseConfig } from '../environment';

// load pipes
import { HasPropertyPipe } from '../pipes/has-property';
import { WithoutPropertyPipe } from '../pipes/without-property';

@NgModule({
  declarations: [
    KasootAdminApp,
    HasPropertyPipe,
    WithoutPropertyPipe,
  ],
  imports: [
    BrowserModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    IonicModule.forRoot(KasootAdminApp),
    AngularFireModule.initializeApp(firebaseConfig)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    KasootAdminApp
  ],
  providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}]
})

export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts